import {ChangeDetectorRef, Component, OnInit, ViewChild,} from '@angular/core';
import {ACTIVE_PAGE_KEY} from '@shared/constants/storage-keys';
import {Menu} from 'primeng/menu';


import {NavigationEnd, Router} from '@angular/router';
import {TooltipModule} from 'primeng/tooltip';

import {ToastModule} from 'primeng/toast';
import {IconArchiveBookComponent} from '../../icons/icon-archive-book/icon-archive-book.component';
import {IconArrowSquareLeftComponent} from '../../icons/icon-arrow-square-left/icon-arrow-square-left.component';
import {IconHomeComponent} from '../../icons/icon-home/icon-home.component';
import {IconLogoutComponent} from "../../icons/icon-logout/icon-logout.component";
import {AuthService} from '../../../core/services/auth.service';
import {IconProfile2UserComponent} from "../../icons/icon-profile-2-user/icon-profile-2-user.component";
import {UsuarioExternoService} from '../../../core/services/usuario-externo.service';
import {environment} from '../../../../environments/environment';
import {BREADCRUMB_MAP, PageInfo} from '../../../core/models/breadcrumbs';
import {
    IconArrowSquareRightComponent
} from '@components/icons/icon-arrow-square-right/icon-arrow-square-right.component';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [
        TooltipModule,
        ToastModule,
        IconHomeComponent,
        IconArchiveBookComponent,
        IconArrowSquareLeftComponent,
        IconLogoutComponent,
        IconProfile2UserComponent,
        IconArrowSquareRightComponent
    ],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
    @ViewChild('menu') menu!: Menu;
    isExpanded = false;
    isAdmin: boolean = false;
    isAuthenticated: boolean = false;
    activePage: PageInfo = {
        breadcrumb: [{label: 'Início', iconComponent: 'home', route: '/'}],
        title: 'Início',
        route: '/',
    };
    activeRoute: string = '/';
    breadcrumbMap: { [route: string]: PageInfo } = BREADCRUMB_MAP;
    protected readonly version: string = environment.version;

    constructor(
        private readonly router: Router,
        private readonly cdr: ChangeDetectorRef,
        private readonly authService: AuthService,
        private readonly userService: UsuarioExternoService
    ) {
        this.isAuthenticated = this.authService.isAuthenticated();

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateActivePage(event.urlAfterRedirects);
            }
        });
    }

    ngOnInit(): void {
        this.getUsuarioLogado();
        this.cdr.detectChanges();

        const savedPage = localStorage.getItem(ACTIVE_PAGE_KEY);
        if (savedPage) {
            this.activePage = JSON.parse(savedPage);
        } else {
            this.activePage = this.breadcrumbMap['/'];
        }

        this.updateActivePage(this.router.url);
    }

    toggleSidebar() {
        this.isExpanded = !this.isExpanded;
    }

    navigate(page: any) {
        this.activePage = this.breadcrumbMap[page.route] ?? {
            breadcrumb: [{label: page.firstLabel, iconComponent: page.iconComponent}, {
                label: page.label,
                iconComponent: page.iconComponent
            }],
            title: `${page.firstLabel} ${page.label}`,
            route: page.route,
        };
        localStorage.setItem(ACTIVE_PAGE_KEY, JSON.stringify(this.activePage));
        this.router.navigate([page.route]).then(() => {
        });
    }

    isSelected(route: string): boolean {
        return this.activeRoute === route;
    }


    logout() {
        this.authService.logout();
    }

    updateActivePage(url: string) {
        const normalizedUrl = url.split('?')[0].split('#')[0];

        if (this.breadcrumbMap[normalizedUrl]) {
            this.activePage = this.breadcrumbMap[normalizedUrl];
            this.activeRoute = normalizedUrl;
        } else {
            this.activePage = this.breadcrumbMap['/'];
            this.activeRoute = '/';
        }

        localStorage.setItem(ACTIVE_PAGE_KEY, JSON.stringify(this.activePage));
    }

    getUsuarioLogado() {
        if (this.authService.isAuthenticatedGovBr()) {
            this.isAdmin = false;
            return;
        }
        if (this.authService.isAuthenticated()) {
            this.userService.getUsuarioLogado().subscribe({
                next: () => {
                    this.userService.isAdministrador().subscribe(isAdmin => {
                        this.isAdmin = isAdmin;
                    });
                },
                error: () => {
                    this.isAdmin = false;
                }
            });
        }
    }
}
